import { createActions } from 'redux-actions';

import types from 'state/direct-order/extras/actionTypes';

const { directOrder } = createActions({
  [types.SET_EXTRA]: (extra) => ({ extra }),
  [types.SET_EXTRAS]: (extras) => ({ extrasValues: extras }),
});

export default directOrder;
